import * as yup from 'yup'
import { TYPE_REQUIRED, TYPE_UNMATCHED_PASSWORD } from 'constants/errors'

export default yup.object().shape({
  current_password: yup.string().required(TYPE_REQUIRED),
  new_password: yup.string().required(TYPE_REQUIRED),
  password_confirm: yup.string().required(TYPE_REQUIRED)
    .test('passwords-match', TYPE_UNMATCHED_PASSWORD, function arePasswordsMatch () {
      return this.parent.new_password === this.parent.password_confirm
    }),
})
